<select [(ngModel)]="yesNo" (ngModelChange)="setYesNo()" name="yesNo" [disabled]="disabled">
  <option *ngIf="!required" [value]="undefined">{{allLabel ? allLabel : 'All'}}</option>
  <option value="true">{{yesOption}}</option>
  <option value="false">{{noOption}}</option>
</select>
